import DescriptionOnlyFormValues from "../ReusableFormValues/DescriptionOnlyFormValues";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { authorizedSignatoryDocumentTypesArray } from "./constants";

export type Props = {
  readonly: boolean;
  documentName?: string;
};

const AuthorizedSignatoryFormValues = ({ readonly, documentName = "" }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={authorizedSignatoryDocumentTypesArray}
        placeholder="Select an authorized signatory list document type"
        name="secondaryDocumentType"
        label="Document sub-type"
        documentName={documentName}
      />
      <DescriptionOnlyFormValues readonly={readonly} />
    </>
  );
};

export default AuthorizedSignatoryFormValues;
